import React, { MouseEvent } from "react";
import Box from "@mui/material/Box";
import { getBlockConfig } from "../../models/block";
import { colors } from "../../styles/theme";
import Tooltip from "@mui/material/Tooltip";
import { BlockImage } from "../block/BlockImage";
import { useAppSelector } from "../../hooks";
import { selectAccountBalance } from "../../store/game/selectors";
import { BlockTypes } from "../../models/block-types";

interface Props {
  blockType: BlockTypes;
  onItemClick: (
    e: MouseEvent<HTMLButtonElement | HTMLDivElement>,
    blockType: BlockTypes,
  ) => void;
  disableInteractivity?: boolean;
}

export const PaletteItem: React.FC<Props> = ({
  blockType,
  onItemClick,
  disableInteractivity = false,
}) => {
  const config = getBlockConfig(blockType);
  const accountBalance = useAppSelector((state) =>
    selectAccountBalance(state.game),
  );
  const canAfford = accountBalance >= config.purchasePrice;
  const isDisabled = !disableInteractivity && !canAfford;

  const backgroundColor = isDisabled ? colors.grey[300] : "white";
  const hoverBackgroundColor = isDisabled ? colors.grey[300] : colors.grey[100];
  const cursor = isDisabled ? "not-allowed" : "pointer";
  return (
    <Box
      draggable
      onDragStart={(e) => {
        e.dataTransfer.setData("application/reactflow", blockType);
        e.dataTransfer.effectAllowed = "move";

        const img = e.currentTarget.querySelector("img");
        if (img) {
          const clone = img.cloneNode(true) as HTMLElement;
          clone.style.opacity = "0.5";
          clone.style.position = "absolute";
          clone.style.top = "-1000px";
          clone.style.left = "-1000px";
          document.body.appendChild(clone);
          e.dataTransfer.setDragImage(clone, 0, 0);

          // Remove the clone after a short delay to ensure it's used for the drag image
          setTimeout(() => {
            document.body.removeChild(clone);
          }, 0);
        }
      }}
      sx={{
        width: "70px",
        height: "70px",
        border: "solid black 1px",
        cursor,
        backgroundColor,
        "&:hover": {
          backgroundColor: hoverBackgroundColor,
        },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "5px",
      }}
      onClick={(e) => onItemClick(e, blockType)}
    >
      {disableInteractivity && (
        <Box>
          <BlockImage width={60} height={60} blockType={blockType} />
        </Box>
      )}
      {!disableInteractivity && (
        <Tooltip title={`${config.displayName}: $${config.purchasePrice}`}>
          <Box>
            <BlockImage width={60} height={60} blockType={blockType} />
          </Box>
        </Tooltip>
      )}
    </Box>
  );
};
